angular.module('mtic')
.service('LocaleService', function (
  $log,
  $location,
  $http,
  language,
  URL_VERSIONS,
  $timeout,
  PlatformService
) {

    var LocaleService = {};

    // constants
    var availableLocales = [
      'LUXEMBOURG',
      'PORTUGAL',
      'CANADA/ONTARIO',
      'CANADA/ONTARIO/TCDSB',
      'CANADA/ONTARIO/BROCKU',
      'INTERNATIONAL'
    ];
    var domainMappingInverse = {
      LUXEMBOURG: [
        'www.mathematic.lu',
        'mathematic.lu',
        'mthmtclu.vretta.com',
        'mthmtc.vretta.com',
        'mthmtc-preview2.vretta.com',
        'localhost',
      ],
      INTERNATIONAL: [
        'DEFAULT'
      ]
    };
    var QcDomains = [
      // 'mthmtclu.vretta.com',
      // 'mthmtc.vretta.com',
      'preview',
      'localhost',
      'edge'
    ]

    // state
    var currentLocale = null;
    var DEFAULT_DOMAIN = 'DEFAULT';
    var ipBasedCountry = null;
    var registered_observers = [];
    var setLuxThroughLocation = false;
    var currentUrlVersion = 'Live';
    var isIamUser = false;
    var loading;

    // globally accessible service props (avoid using this format)
    LocaleService.hasCompletedStudentQuest = false;
    LocaleService.hasCompletedStudentBase = false;
    LocaleService.hasTakenStudentCyclePrompt = false;
    LocaleService.is_c4_student = false;
    LocaleService.done_student_post_test = false;
    LocaleService.done_student_offboarding = false;
    LocaleService.idleInput = false;
    LocaleService.idleFocus = false;
    LocaleService.isAway = false;
    LocaleService.item_link_opened = false;

    // private service methods
    var initService = function(){
      checkIpStack()
    }
    var notifyObservers = function(){
      registered_observers.forEach(function(observer){
        observer();
      })
    }
    var findLocaleSlugByDomain = function(matchToDomain){
      var matchingLocaleSlug = null;
      _.each(domainMappingInverse, function(domainList, localeSlug){
        _.each(domainList, function(domainName){
          if (domainName === matchToDomain){
              matchingLocaleSlug = localeSlug;
          }
        });
      });
      return matchingLocaleSlug
    }
    var computeCurrentUrlVersion = function(){
      var currentDomainName =  $location.host();
      var hrefName = window.location.href;
      if (_.find(QcDomains, function(el){return hrefName.indexOf(el) > -1})) {
        currentUrlVersion = URL_VERSIONS.Preview;
      }
      if(hrefName.indexOf('preview') !== -1){
        currentUrlVersion = URL_VERSIONS.Preview;
      }
      if(hrefName.indexOf('pre-live') !== -1 || hrefName.indexOf('prelive2') !== -1){
        currentUrlVersion = URL_VERSIONS.Prelive;
      }
      if(currentDomainName.indexOf('mathematic.lu') > -1 || currentDomainName.indexOf('mathematic.org') > -1){
        currentUrlVersion = URL_VERSIONS.Live;
      }
    }
    var updateCurrentLocale = function(){
      computeCurrentUrlVersion();

      var currentDomainName =  $location.host();
      var hrefName = window.location.href;
      var matchingLocaleSlug = findLocaleSlugByDomain(currentDomainName);
      if (!matchingLocaleSlug){
          matchingLocaleSlug = findLocaleSlugByDomain(DEFAULT_DOMAIN);
      }

        if(window.isWebEmbedConnect && !setLuxThroughLocation){
          currentLocale = 'INTERNATIONAL';
        } else if (PlatformService.getQueryVariable('force-ocmt')) {
          currentLocale = 'INTERNATIONAL';
        } else if (PlatformService.getQueryVariable('force-international')) {
          currentLocale = 'INTERNATIONAL';
        }else if(!setLuxThroughLocation){
          currentLocale = matchingLocaleSlug;
        }else{
          currentLocale = 'LUXEMBOURG';
        }
    }
    var checkIpStack = function(){
      loading = true;
      $http.get("https://api.ipstack.com/check?access_key=0019e468e33db16ccac92651d7887192").then(function(response) {
        $log.log('Location info: ', response.data);
        ipBasedCountry = response.data.country_code;
        if(response.data.country_code === 'LU'){
          currentLocale = 'LUXEMBOURG';
          setLuxThroughLocation = true;
        }else if(response.data.country_code === 'PT'){
          language.set('pt', true)
        }
        notifyObservers();
        loading = false;
      }).catch(function(err){
        loading = false;
      });
    }

    // public service methods
    LocaleService.registerObserver = function(observer){
      registered_observers.push(observer);
    }
    LocaleService.checkUrlVersion = function(urlVersion){
      return (currentUrlVersion === urlVersion)
    }
    LocaleService.getIpBasedCountry = function(){
      return ipBasedCountry;
    }
    LocaleService.getAvailableLocales = function(){
      return availableLocales;
    }
    LocaleService.setCurrentLocale = function(val){
      currentLocale = val;
    }
    LocaleService.computeCurrentUrlVersion = function(){
      computeCurrentUrlVersion();
    }
    LocaleService.getCurrentLocale = function(){
      if(loading){
        return null;
      }
      if (currentLocale === null){
          updateCurrentLocale();
      }
      return currentLocale;
    }
    LocaleService.getUrlVersion = function(){
      return currentUrlVersion;
    }
    LocaleService.isCurrentLocale = function(localeSlug){
        return ( localeSlug === LocaleService.getCurrentLocale() );
    }
    LocaleService.setAsIamUser = function(){
      isIamUser = true;
    }
    LocaleService.getIfIamUser = function(){
      return isIamUser;
    }

    // init
    initService();

    return LocaleService;

});

